module.exports = __webpack_public_path__ + "img/aws-pro-cert.c387248d.png";